import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {Item, List} from '@/components/core';
import Pager from '../_common/pager';
import mock from '../_data/newslist'
import axios from 'axios';


const formatDate = (time) => {
  if (!time) return '';
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 补零
  const day = String(date.getDate()).padStart(2, '0'); // 补零
  const hours = String(date.getHours()).padStart(2, '0'); // 补零
  const minutes = String(date.getMinutes()).padStart(2, '0'); // 补零
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};



const adapter = (item) => {
  return {
    // title: {title: '返回', itemClass: 'pages-back', onClick() {
    //   window.history.back()
    // }},
    dot: [
      { title: item.noticeTitle, itemClass: 'pages-title mb-default' },
      { title: formatDate(item.releasedTime), itemClass: 'ss-center mb-default' },
      { title: <div dangerouslySetInnerHTML={{__html: item.noticeContent}}></div> }
    ]
  }
}
const itemCfg = {
  attached() {},
  bodyClass: 'item-type',
  itemClass: 'item-detail wid1200',
  async ready() {
    const id = window.location.search.split('?id=')[1]
    // const getData = mock.filter(item => item.id === id)
    const res = await axios.get(`/api/api/article/${id}`);
    // const data = {
    //     title: '明心数智与上海银行深圳前海分行签署战略合作协议',
    //     desc: '海银行以“精品银行”为战略愿景，以“精诚至上，信义立行”为核心价值观，近年来通过推进专业化经营和精细化管理，服务能级不断增强，目前在多个城市设立分支机构，形成长三角、京津冀、粤港澳大湾区和中西部重点城市的布局框架；上海银行深圳分行从2009年成立至今，一直致力于推进产品和服务的创新，多层次的满足不同行业客户的金融服务需求，且经营业绩一直处于深圳地区异地城市商业银行的首列。',
    //     content: '<p>上海银行以“精品银行”为战略愿景，以“精诚至上，信义立行”为核心价值观，近年来通过推进专业化经营和精细化管理，服务能级不断增强，目前在多个城市设立分支机构，形成长三角、京津冀、粤港澳大湾区和中西部重点城市的布局框架；上海银行深圳分行从2009年成立至今，一直致力于推进产品和服务的创新，多层次的满足不同行业客户的金融服务需求，且经营业绩一直处于深圳地区异地城市商业银行的首列。</p><br/><br/> <p> 上海银行深圳前海分行于2020年8月18日正式成立，为上海银行深圳分行设立的首家同城二级分行。上海银行深圳前海分行紧紧依托上海银行的“智慧金融，专业服务”理念，充分利用前海合作区的政策、资源及区位优势，在跨境金融、供应链金融、科创金融等领域主动作为，服务前海合作区经济发展；深度对接“港澳所需”、“湾区所向”，为湾区城市群提供优质的综合金融服务。</p><br/><br/> <p> 明心数智作为一家产业经营评估及数字化服务商，已服务了100多家产业互联网平台和核心企业。明心数智通过构建产业经营评估和监测体系，帮助金融机构为产业链生态的中小微企业提供更优质的普惠金融服务。</p><br/><br/> <p> 此次战略合作，明心将助推金融机构产品及服务的创新落地，双方通过资源共享、优势互补与业务创新，共同为客户提供多元化的数字金融服务，促进产业和金融更深层次的融合。</p>',
    //     img: '/images/news/new_detail7.jpg',
    //     id: '7',
    //     date: '2022-11-01'
    //   }
    const data = res.data.data
    document.getElementsByTagName("title")[0].innerText = '深圳市明心数智科技有限公司-' + data.noticeTitle;
    const rdata = adapter(data)
    console.log(rdata);
    
    this.reset(rdata)
  }
}

const PagesBody = props => {
  return (
    <div className="pages-news-wrap">
      <Item {...itemCfg} />
    </div>
  )
}
const adapterList = (data) => {
  return data.map(item => {
    return {
      title: <div className="item-pic"><img src={item.img} /></div>,
      body: [
        { title: item.title, itemClass: 'item-title mb-small textellipsis-auto-1' },
        { title: item.date, itemClass: 'item-time mb-primary' },
        { title: item.desc, itemClass: 'item-desc textellipsis-auto-3' },
      ],
      bodyClass: 'item-body',
      itemClass: 'item',
      url: '/news?id'+item.id
    }
  })
}
const PagesBodyFooter = props => {
  const res = mock.slice(0, 3)
  const listCfg = {
    data: adapterList(res),
    listClass: 'pages-news'
  }
  return (
    <div className="pages-news-wrap list">
      <div className='wid1200'>
        <List {...listCfg} />
      </div>
    </div>
  )
}


const App = (props) => {
  const cfg = {
    banner: {
      data: [
        {
          img: '/images/about/news.jpg',
          content: {
            title: '新闻动态',
            desc: '动态内容，尽在了解',
            className: 'color-fff'
          },
          showButton: false
        }
      ]
    },
    body: <PagesBody />,
    // bodyfooter: <PagesBodyFooter />
  }
  return <Pager {...cfg} />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)